import React, { ReactElement, useEffect, useRef, useState } from 'react';

import { VideoProviderEnum } from 'features/contents';
import { VimeoPlayer, ProtectedVideoPlayer, YoutubePlayer, PandaPlayer, SambaPlayerNew } from './components';
import { VideoPlayerProps } from './types';
import { useSchool } from 'features/school';

declare global {
  interface Window {
    VdoPlayer: any;
    playerContainer: any;
    vdo: any;

    pandascripttag: any;
    PandaPlayer: any;
    SambaPlayer: any;
    Spalla?: any;

    eventListener: (player: any) => void;
    sambaPlayer: any;
  }
}

const Player = ({ videoProvider, ...props }: VideoPlayerProps): ReactElement => {
  const {
    uiSettings: { logoUrl },
    schoolAlias,
  } = useSchool();

  const [showSplash, setShowSplash] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        aspectRatio: '16 / 9',
        backgroundColor: '#000',
      }}
    >
      {videoProvider === VideoProviderEnum.Vimeo && <VimeoPlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.ProtectedVideo && <ProtectedVideoPlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.Youtube && <YoutubePlayer videoProvider={videoProvider} {...props} />}

      {videoProvider === VideoProviderEnum.Panda && <PandaPlayer videoProvider={videoProvider} {...props} />}

      {/* {videoProvider === VideoProviderEnum.SambaVideo && <SambaPlayer videoProvider={videoProvider} {...props} />} */}
      {videoProvider === VideoProviderEnum.SambaVideo && <SambaPlayerNew videoProvider={videoProvider} {...props} />}
      {showSplash && schoolAlias === 'TestSchool' && (
        <div
          ref={containerRef}
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <img src={logoUrl} alt="Logo" style={{ maxWidth: '200px' }} />
        </div>
      )}
      {schoolAlias === 'TestSchool' && (
        <img
          src={logoUrl}
          alt="Logo"
          style={{
            position: 'absolute',
            bottom: 70,
            right: 16,
            width: 60,
            opacity: 0.7,
            zIndex: 5,
            pointerEvents: 'none',
          }}
        />
      )}
    </div>
  );
};
export default Player;
